import { cn } from "@kazaar-platform/design-system";
import clsx from "clsx";
import { type ReactNode, type RefObject, type UIEventHandler } from "react";
import { injectDataCy } from "@/helpers/injectDataCy";

export type PageTemplateType = {
  children: ReactNode;
  className?: string;
  dataCy?: string;
};

type PageTemplateHeaderType = {
  children: ReactNode;
  className?: string;
  transparent?: boolean;
};

type PageTemplateContentType = {
  children: ReactNode;
  contentRef?: RefObject<HTMLDivElement | null>;
  wrapperClassName?: string;
  className?: string;
  onScroll?: UIEventHandler<HTMLDivElement>;
};

export const PageTemplate = ({
  children,
  className,
  dataCy,
}: PageTemplateType) => {
  // Define ClassNames Array
  const classNames = cn(
    "flex flex-col items-center overflow-auto h-full w-full",
    className
  );

  return (
    <div className={classNames} {...injectDataCy(dataCy)}>
      {children}
    </div>
  );
};

const PageTemplateHeader = ({
  children,
  className,
}: PageTemplateHeaderType) => {
  // Define ClassNames Array
  const classNames = clsx("z-20 flex w-full justify-center", className);

  return <div className={classNames}>{children}</div>;
};

PageTemplateHeader.displayName = "PageTemplateHeader";
PageTemplate.Header = PageTemplateHeader;

const PageTemplateContent = ({
  contentRef,
  children,
  wrapperClassName,
  className,
  onScroll,
}: PageTemplateContentType) => {
  // Define ClassNames Array
  const wrapperStyle = cn(
    "z-0 flex w-full flex-1 justify-center overflow-y-auto overflow-x-hidden",
    wrapperClassName
  );
  const classNames = cn(
    "flex w-full h-full max-w-[1800px] px-10 py-10",
    className
  );

  return (
    <div ref={contentRef} onScroll={onScroll} className={wrapperStyle}>
      <div className={classNames}>{children}</div>
    </div>
  );
};

PageTemplateContent.displayName = "PageTemplateContent";
PageTemplate.Content = PageTemplateContent;
